/* PMSTEEL · Floating island: Saved + Recently viewed + Cart in ONE dock on the
   right edge (review feedback 07-16 — replaces the two bottom-left pills that
   overlapped). Heart buttons on cards/PDPs save to localStorage (pmsteel-favs);
   recently-viewed reads the existing pmsteel_rv store (recorded on PDPs by
   snippets/pmsteel-recently-viewed.liquid); cart count is live from /cart.js.
   The x collapses the island to a slim edge tab that brings it back — the
   choice is remembered (localStorage) until the customer flips it again.
   Toggle: Theme settings → PMSTEEL · Favorites. */
(function () {
  var FAV_KEY = 'pmsteel-favs';
  var RV_KEY = 'pmsteel_rv';
  var HIDE_KEY = 'pmsteel-island-hidden';

  function readJSON(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function writeFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  /* BATCH-C-001 GATE2 (2026-09-25): retailer-only products used to stamp a
     formatted "$0.00" price into these two localStorage caches before this
     ticket's fix (which now stamps an empty string at write time — see
     snippets/pmsteel-recently-viewed.liquid and snippets/pmsteel-fav-button.liquid).
     Anyone who saved/viewed one of those products before today still has the
     stale "$0.00" sitting in their browser. Rather than bump the storage key
     (which would silently wipe every visitor's saved items and recently-viewed
     history, not just the affected entries), do a one-time in-place scrub: blank
     any cached price string that is just a zero amount (optionally with a
     currency symbol), then write the list back under the same key. Simpler,
     less disruptive, and self-healing on next page load for anyone still
     carrying a stale value. */
  var ZERO_PRICE_RE = /^\s*[^\d]*0([.,]00)?\s*$/;
  function normalizeStalePrices() {
    try {
      var favs = readJSON(FAV_KEY);
      if (Array.isArray(favs)) {
        var favsChanged = false;
        favs.forEach(function (f) {
          if (f && typeof f.price === 'string' && f.price && ZERO_PRICE_RE.test(f.price)) {
            f.price = '';
            favsChanged = true;
          }
        });
        if (favsChanged) writeFavs(favs);
      }
      var views = readJSON(RV_KEY);
      if (Array.isArray(views)) {
        var rvChanged = false;
        views.forEach(function (x) {
          if (x && typeof x.p === 'string' && x.p && ZERO_PRICE_RE.test(x.p)) {
            x.p = '';
            rvChanged = true;
          }
        });
        if (rvChanged) localStorage.setItem(RV_KEY, JSON.stringify(views));
      }
    } catch (e) { /* private mode / corrupt cache: leave as-is */ }
  }
  function favIdentity(fav) {
    if (!fav || typeof fav !== 'object') return '';
    if (fav.variantId) return 'variant:' + fav.variantId;
    return fav.handle ? 'product:' + fav.handle : '';
  }
  function readFavs() {
    var list = readJSON(FAV_KEY);
    return Array.isArray(list) ? list.filter(function (fav) { return favIdentity(fav); }) : [];
  }
  function hasFav(fav) {
    var identity = favIdentity(fav);
    return identity && readFavs().some(function (saved) { return favIdentity(saved) === identity; });
  }
  function fmtMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- island markup ---------- */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.3C.6 8.4 2.4 4.9 6 4.9c2 0 3.4 1.1 4.2 2.4h1.6c.8-1.3 2.2-2.4 4.2-2.4 3.6 0 5.4 3.5 4 6.8C19.5 16.1 12 21 12 21z"/></svg>';
  var EYE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5C5.5 5 1 12 1 12s4.5 7 11 7 11-7 11-7-4.5-7-11-7zm0 11.5A4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>';
  var CART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM7.2 14.8c0 .1.1.2.2.2h11.1v2H7c-1.2 0-2.2-.9-2.4-2L2.4 4H0V2h4l.6 3h18.2l-2.5 8.7c-.2.8-1 1.4-1.9 1.4H7.5l-.3-.3z"/></svg>';

  var root = document.createElement('div');
  root.className = 'pmisl';
  root.innerHTML =
    '<div class="pmisl__dock" hidden>' +
    '  <button type="button" class="pmisl__btn" data-pmisl-panel="favs" aria-label="Saved items">' + HEART + '<span class="pmisl__count" data-pmisl-favcount hidden>0</span></button>' +
    '  <button type="button" class="pmisl__btn" data-pmisl-panel="rv" aria-label="Recently viewed">' + EYE + '<span class="pmisl__count" data-pmisl-rvcount hidden>0</span></button>' +
    '  <button type="button" class="pmisl__btn" data-pmisl-panel="cart" aria-label="Cart">' + CART + '<span class="pmisl__count" data-pmisl-cartcount hidden>0</span></button>' +
    '  <button type="button" class="pmisl__hide" data-pmisl-hide aria-label="Hide this panel">&times;</button>' +
    '</div>' +
    '<button type="button" class="pmisl__tab" data-pmisl-show hidden aria-label="Show saved items and cart">&#8249;</button>' +
    '<div class="pmisl__panel" data-pmisl-panelbox hidden>' +
    '  <div class="pmisl__panel-head"><span data-pmisl-title></span><button type="button" class="pmisl__panel-close" data-pmisl-close aria-label="Close">&times;</button></div>' +
    '  <div class="pmisl__panel-list" data-pmisl-list></div>' +
    '</div>';
  document.body.appendChild(root);

  var dock = root.querySelector('.pmisl__dock');
  var tab = root.querySelector('[data-pmisl-show]');
  var panel = root.querySelector('[data-pmisl-panelbox]');
  var listEl = root.querySelector('[data-pmisl-list]');
  var titleEl = root.querySelector('[data-pmisl-title]');
  var cartCount = 0;
  var cartData = null;
  var openPanel = null;
  var panelVersion = 0;
  var cartRefreshSequence = 0;
  var lastAppliedCartRefresh = 0;

  var panelButtons = root.querySelectorAll('[data-pmisl-panel]');
  var hideButton = root.querySelector('[data-pmisl-hide]');
  function disclosureId(base) {
    var id = base;
    var suffix = 1;
    while (document.getElementById(id)) id = base + '-' + suffix++;
    return id;
  }
  var panelId = disclosureId('pmisl-panel');
  panel.setAttribute('id', panelId);
  var dockId = disclosureId('pmisl-dock');
  dock.setAttribute('id', dockId);
  panelButtons.forEach(function (button) {
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('aria-expanded', 'false');
  });
  [hideButton, tab].forEach(function (button) {
    button.setAttribute('aria-controls', dockId);
    button.setAttribute('aria-expanded', 'false');
  });
  function setExpanded(button, expanded) {
    var value = expanded ? 'true' : 'false';
    if (button.getAttribute('aria-expanded') !== value) button.setAttribute('aria-expanded', value);
  }
  function syncDisclosure() {
    panelButtons.forEach(function (button) {
      setExpanded(button, !panel.hidden && openPanel === button.getAttribute('data-pmisl-panel'));
    });
    setExpanded(hideButton, !dock.hidden);
    setExpanded(tab, !dock.hidden);
  }

  function captureRemovalFocus(control, which, selector) {
    if (openPanel !== which || panel.hidden || !panel.contains(control)) return null;
    var index = Array.prototype.indexOf.call(listEl.querySelectorAll(selector), control);
    return index < 0 ? null : { control: control, which: which, selector: selector, index: index, version: panelVersion };
  }

  function removalFocusUnmoved(intent) {
    var active = document.activeElement;
    return !active || active === document.body || active === intent.control || !active.isConnected;
  }

  function removalControlVisible(control) {
    return control && control.isConnected && !control.disabled && !control.closest('[hidden]') &&
      control.getClientRects().length > 0 && window.getComputedStyle(control).visibility === 'visible';
  }

  function prepareRemovalFocus(intent) {
    if (!intent || intent.version !== panelVersion || openPanel !== intent.which || panel.hidden || !removalFocusUnmoved(intent)) return null;
    return function () {
      if (intent.version !== panelVersion || !removalFocusUnmoved(intent)) return;
      if (openPanel === intent.which && !panel.hidden) {
        var controls = listEl.querySelectorAll(intent.selector);
        if (intent.key !== undefined) {
          for (var k = 0; k < controls.length; k++) {
            if (controls[k].getAttribute(intent.keyAttribute) === intent.key && removalControlVisible(controls[k])) { controls[k].focus(); return; }
          }
        }
        for (var i = Math.min(intent.index, controls.length - 1); i >= 0; i--) {
          if (removalControlVisible(controls[i])) { controls[i].focus(); return; }
        }
        var close = panel.querySelector('[data-pmisl-close]');
        if (removalControlVisible(close)) { close.focus(); return; }
      } else if (!panel.hidden) {
        return;
      }
      var dockControls = dock.querySelectorAll('button');
      for (var j = 0; j < dockControls.length; j++) {
        if (removalControlVisible(dockControls[j])) { dockControls[j].focus(); return; }
      }
      if (removalControlVisible(tab)) tab.focus();
    };
  }

  function prepareListFocus(which) {
    var active = document.activeElement;
    var attribute = which === 'cart' ? 'data-pmisl-cartrm' : 'data-pmisl-rm';
    var selector = '[' + attribute + ']';
    if (!active || !listEl.contains(active) || !active.matches(selector) || !removalControlVisible(active)) return null;
    var intent = captureRemovalFocus(active, which, selector);
    if (!intent) return null;
    intent.keyAttribute = attribute;
    intent.key = active.getAttribute(attribute);
    return prepareRemovalFocus(intent);
  }

  function rv() {
    // includes the product currently being viewed on purpose - hiding it made
    // the count appear to drop when opening a PDP (review feedback 07-16)
    return readJSON(RV_KEY).filter(function (x) { return x && x.h; });
  }

  function counts() {
    return { favs: readFavs().length, rv: rv().length, cart: cartCount };
  }

  function render() {
    var c = counts();
    var favEl = root.querySelector('[data-pmisl-favcount]');
    var rvEl = root.querySelector('[data-pmisl-rvcount]');
    var cartEl = root.querySelector('[data-pmisl-cartcount]');
    favEl.textContent = c.favs; favEl.hidden = !c.favs;
    rvEl.textContent = c.rv; rvEl.hidden = !c.rv;
    cartEl.textContent = c.cart; cartEl.hidden = !c.cart;
    var any = c.favs || c.rv || c.cart;
    var hidden = localStorage.getItem(HIDE_KEY) === '1';
    dock.hidden = !any || hidden;
    tab.hidden = !any || !hidden;
    if (!any || hidden) { panel.hidden = true; openPanel = null; }
    syncDisclosure();
    syncHearts();
  }

  function renderList(which) {
    if (which === 'favs') {
      var favs = readFavs();
      titleEl.textContent = 'Saved items';
      listEl.innerHTML = favs.length
        ? favs.map(function (f) {
            return '<div class="pmisl__item">' +
              (f.image ? '<a href="' + esc(f.url) + '"><img src="' + esc(f.image) + '" alt="" loading="lazy" width="56" height="56"></a>' : '') +
              '<div class="pmisl__item-meta"><a class="pmisl__item-t" href="' + esc(f.url) + '">' + esc(f.title) + '</a>' + (f.price ? '<span class="pmisl__item-p">' + esc(f.price) + '</span>' : '') + '</div>' +
              '<button type="button" class="pmisl__item-rm" data-pmisl-rm="' + esc(favIdentity(f)) + '" aria-label="Remove ' + esc(f.title) + ' from saved items">&times;</button></div>';
          }).join('')
        : '<p class="pmisl__empty">Nothing saved yet. Tap the heart on any product.</p>';
    } else if (which === 'cart') {
      titleEl.textContent = 'Cart';
      var items = (cartData && cartData.items) || [];
      var rows = items.length
        ? items.map(function (it) {
            return '<div class="pmisl__item">' +
              (it.image ? '<a href="' + esc(it.url) + '"><img src="' + esc(it.image) + '" alt="" loading="lazy" width="56" height="56"></a>' : '') +
              '<div class="pmisl__item-meta"><a class="pmisl__item-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
              '<span class="pmisl__item-q">' + it.quantity + ' × ' + esc(fmtMoney(it.final_price)) + '</span></div>' +
              '<button type="button" class="pmisl__item-rm" data-pmisl-cartrm="' + esc(it.key) + '" aria-label="Remove ' + esc(it.product_title) + (it.variant_title && it.variant_title !== 'Default Title' ? ' – ' + esc(it.variant_title) : '') + ' from cart">&times;</button></div>';
          }).join('')
        : '<p class="pmisl__empty">Your cart is empty.</p>';
      listEl.innerHTML = rows +
        (items.length ? '<div class="pmisl__foot"><span class="pmisl__subtotal">' + esc(fmtMoney(cartData.items_subtotal_price)) + '</span><a class="pmisl__viewcart" href="/cart">View cart</a></div>' : '');
    } else {
      var views = rv();
      titleEl.textContent = 'Recently viewed';
      listEl.innerHTML = views.length
        ? views.map(function (x) {
            return '<div class="pmisl__item">' +
              (x.i ? '<a href="' + esc(x.u) + '"><img src="' + esc(x.i) + '" alt="" loading="lazy" width="56" height="56"></a>' : '') +
              '<div class="pmisl__item-meta"><a class="pmisl__item-t" href="' + esc(x.u) + '">' + esc(x.t) + '</a>' + (x.p ? '<span class="pmisl__item-p">' + esc(x.p) + '</span>' : '') + '</div></div>';
          }).join('')
        : '<p class="pmisl__empty">No recently viewed products.</p>';
    }
  }

  function syncHearts() {
    document.querySelectorAll('[data-pmfav-toggle]').forEach(function (btn) {
      var on = hasFav(btn.dataset);
      btn.classList.toggle('pmfav-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function syncPdpHeart(event) {
    var data = event && event.data;
    if (!data || !data.sectionId || !data.html || typeof data.html.querySelector !== 'function') return;
    var selector = 'product-form[data-section-id="' + data.sectionId + '"] [data-pmfav-toggle].pmfav-heart--pdp';
    var source = data.html.querySelector(selector);
    var target = document.querySelector(selector);
    if (!source || !target) return;
    ['handle', 'variantId', 'title', 'price', 'image', 'url'].forEach(function (key) {
      target.dataset[key] = source.dataset[key] || '';
    });
    var label = source.getAttribute('aria-label');
    if (label) target.setAttribute('aria-label', label);
    syncHearts();
  }

  /* ---------- heart clicks: capture phase so the card's full-card link never fires ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pmfav-toggle]');
    if (!toggle) return;
    e.preventDefault();
    e.stopPropagation();
    var favorite = { handle: toggle.dataset.handle, variantId: toggle.dataset.variantId, title: toggle.dataset.title, price: toggle.dataset.price, image: toggle.dataset.image, url: toggle.dataset.url };
    var identity = favIdentity(favorite);
    var list = readFavs();
    if (hasFav(favorite)) {
      list = list.filter(function (saved) { return favIdentity(saved) !== identity; });
    } else {
      list.push(favorite);
      localStorage.removeItem(HIDE_KEY); // saving something brings the island back
    }
    var restoreListFocus = prepareListFocus('favs');
    writeFavs(list);
    if (openPanel === 'favs') renderList('favs');
    render();
    if (restoreListFocus) restoreListFocus();
  }, true);

  /* ---------- island events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var pbtn = t.closest('[data-pmisl-panel]');
    if (pbtn) {
      panelVersion++;
      var which = pbtn.getAttribute('data-pmisl-panel');
      if (openPanel === which) { panel.hidden = true; openPanel = null; syncDisclosure(); return; }
      renderList(which);
      panel.hidden = false;
      openPanel = which;
      syncDisclosure();
      return;
    }
    if (t.closest('[data-pmisl-close]')) { panelVersion++; panel.hidden = true; openPanel = null; syncDisclosure(); return; }
    if (t.closest('[data-pmisl-hide]')) { panelVersion++; localStorage.setItem(HIDE_KEY, '1'); render(); return; }
    if (t.closest('[data-pmisl-show]')) { panelVersion++; localStorage.removeItem(HIDE_KEY); render(); return; }
    var crm = t.closest('[data-pmisl-cartrm]');
    if (crm) {
      var cartRemoval = captureRemovalFocus(crm, 'cart', '[data-pmisl-cartrm]');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: crm.dataset.pmislCartrm, quantity: 0 }) })
        .then(function (response) {
          if (!response.ok) { cartRemoval = null; return; }
          return refreshCart(function () { return prepareRemovalFocus(cartRemoval); })
            .then(function () { cartRemoval = null; });
        })
        .catch(function () { cartRemoval = null; });
      return;
    }
    var rm = t.closest('[data-pmisl-rm]');
    if (rm) {
      var restoreSavedFocus = prepareRemovalFocus(captureRemovalFocus(rm, 'favs', '[data-pmisl-rm]'));
      writeFavs(readFavs().filter(function (fav) { return favIdentity(fav) !== rm.dataset.pmislRm; }));
      renderList('favs');
      render();
      if (restoreSavedFocus) restoreSavedFocus();
      return;
    }
    if (!t.closest('.pmisl')) { panelVersion++; panel.hidden = true; openPanel = null; syncDisclosure(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || e.key !== 'Escape' || panel.hidden || !openPanel) return;
    var returnFocus = panel.contains(document.activeElement);
    var toggle = root.querySelector('[data-pmisl-panel="' + openPanel + '"]');
    panelVersion++;
    panel.hidden = true;
    openPanel = null;
    syncDisclosure();
    if (returnFocus && removalControlVisible(toggle)) toggle.focus();
  });

  /* ---------- cart count ---------- */
  function refreshCart(beforeRender) {
    var sequence = ++cartRefreshSequence;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Cart refresh failed'); return r.json(); })
      .then(function (cart) {
        if (sequence < lastAppliedCartRefresh) { beforeRender = null; return; }
        var restoreFocus = typeof beforeRender === 'function' ? beforeRender() : null;
        if (!restoreFocus) restoreFocus = prepareListFocus('cart');
        beforeRender = null;
        lastAppliedCartRefresh = sequence;
        cartCount = cart.item_count;
        cartData = cart;
        if (openPanel === 'cart') renderList('cart');
        render();
        if (restoreFocus) restoreFocus();
      })
      .catch(function () { beforeRender = null; });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, syncPdpHeart);
  }
  document.addEventListener('pmsteel:cart:update', refreshCart);

  normalizeStalePrices();
  render();
  refreshCart();
  document.addEventListener('shopify:section:load', syncHearts);
})();
